import React from "react";
import { useSystem, SYSTEM_META } from "@/lib/system";

export default function SystemSwitcher() {
  const { system, setSystem } = useSystem();
  return (
    <div className="inline-flex bg-bg border border-line rounded-sm p-0.5 gap-0.5" data-testid="system-switcher">
      <button
        data-testid="system-all-btn"
        onClick={() => setSystem("")}
        className={`px-3 py-1 text-[10px] uppercase tracking-[0.15em] rounded-sm transition-colors ${
          system === "" ? "bg-cyan/15 text-cyan" : "text-slate-400 hover:text-white"
        }`}
      >
        All Systems
      </button>
      {Object.entries(SYSTEM_META).map(([k, m]) => (
        <button
          key={k}
          data-testid={`system-${k}-btn`}
          onClick={() => setSystem(k)}
          className={`px-3 py-1 text-[10px] uppercase tracking-[0.15em] rounded-sm transition-colors ${
            system === k ? "bg-cyan/15 text-cyan" : "text-slate-400 hover:text-white"
          }`}
        >
          {m.short} · {m.label}
        </button>
      ))}
    </div>
  );
}
